export const muiInputSx = (hasError) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#EFF5F5",
    borderRadius: "0.375rem",
    paddingRight: "2.5rem",
    transition: "box-shadow 150ms, border-color 150ms",
    "& fieldset": {
      borderColor: hasError ? "#ef4444" : "#EDF1F2",
    },
    "&:hover fieldset": {
      borderColor: hasError ? "#ef4444" : "#EDF1F2",
    },
    "&.Mui-focused": {
      boxShadow: hasError
        ? "0 0 0 2px rgba(248, 113, 113, 0.5)"
        : "0 0 0 2px rgba(34, 197, 94, 0.5)",
    },
    "&.Mui-focused fieldset": {
      borderColor: hasError ? "#ef4444" : "#22c55e",
      borderWidth: "1px",
    },
    "&.Mui-error fieldset": {
      borderColor: "#ef4444",
    },
  },
  "& .MuiFormControl-root": {
    width: "100%",
  },
  "& .MuiOutlinedInput-input": {
    padding: "0.25rem !important",
    color: hasError ? "#dc2626" : "#303030",
  },
  "& .MuiInputBase-root": {
    padding: "0.5rem !important",
  },
  "& .MuiFormHelperText-root": {
    color: "rgb(239 68 68) !important",
    margin: "0.25rem 0px 0px 0px",
    fontSize: "0.875rem",
  },
  "& .MuiStack-root": {
    width: "100%",
  },
});

export const muiMenuItemSx = {
  borderRadius: 2,
  color: "#6b7280",
  display: "flex",
  alignItems: "center",
  gap: 1,
};
